export default __webpack_public_path__ + "static/media/wolf2.125f7b3d.png";